import React from 'react'
import { BiSearchAlt2 } from 'react-icons/bi'

import './stylesPInp.css'

export default function InputPesquisa({
  input,
  onChange,
  onClick,
  textPlace,
  width,
}) {
  return (
    <div className='contain-pesquisa-input' style={{ width: width }}>
      <BiSearchAlt2
        className='icon-pesquisa-input'
        size={30}
        onClick={onClick}
      />
      <input
        className='input-pesquisa-input'
        type='text'
        value={input}
        onChange={onChange}
        placeholder={textPlace}
      />
    </div>
  )
}
